import { IReducerFn, TProfileState } from '../type';

export const TruckerProfileReducer: IReducerFn<TProfileState> = (state, { type, payload }) => {
  switch (type) {
    case 'trucker_profile_set':
      return {
        ...state,
        selected: payload,
      };
    case 'trucker_profile_trading_status_set':
      return {
        ...state,
        status: payload,
      };

    default:
      return state;
  }
};

TruckerProfileReducer.key = 'truckerProfile';
TruckerProfileReducer.initialState = {
  selected: null,
  status: null,
};
